import AxiosClient from "../AxiosClient";

//基本価格表データ取得Api
export const postBasePriceSearchInfoListAPI = (params) => {
  return AxiosClient.post("/api/basePrice/searchInfoList", params);
}

// 基本価格表データ更新Api
export const postBasePriceUpdateInfoListAPI = (params) => {
  return AxiosClient.post("/api/basePrice/updateInfo", params);
}